
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/upsc-admission-nri",
      function () {
        return require("private-next-pages/upsc-admission-nri/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/upsc-admission-nri"])
      });
    }
  